<template lange="html">
  <v-container fluid>
    <v-row>
      <v-col class="xs-12">
        <v-card>
          <v-toolbar>
            <v-btn>
              <v-icon class="mr-2" >settings</v-icon>
              <TText
                value="General_Settings"
                font_weight="500"
                medium
              />
            </v-btn>
          </v-toolbar>
          <div style="padding: 15px;display: flex; flex-direction: column; gap: 5px">
            <TText
              style="padding-left: 10px"
              value="Language_Settings"
              font_weight="500"
              large
            />
            <LocaleChanger/>
            <TText
              style="padding-left: 10px"
              value="Theme_Settings"
              font_weight="500"
              large
            />
            <NavBarSwitch/>
            <StandardSwitch
              v-if="hasPermission('Use Live Sync')"
              class="mt-3"
              :value = "live_sync_setting"
              label = "Live Sync"
              @changeValue="setLiveSyncCookie(!live_sync_setting)"
            />
            <!-- TODO:  oder true rauslöschen für permissions -->
            <div v-if="hasPermission('Language CREATE')">
              <TText
                style="padding: 10px"
                value="Language_Edit_Mode"
                font_weight="500"
                large
              />
              <StandardSwitch
                :value="isEdit"
                @changeValue="switchEdit()"
                icon_class="milestone-icon black"
                icon_style="zoom: 0.7; margin-top: 1px; margin-right: 1px"
              />
            </div>
          </div>
            <ButtonOutlined
                class="ma-2"
                text="Reload Business Permissions"
                icon="restart"
                @buttonClicked="requestBusinessPermissions({id: getBusiness.id})"
            />
            <ButtonOutlined
                class="ma-2"
                text="Reload Permissions"
                icon="restart"
                @buttonClicked="requestPermissions()"
            />
            <ButtonOutlined
                class="ma-2"
                text="Reload Project Permissions"
                icon="restart"
                @buttonClicked="requestPPermissions({is_cached: false, project_id: 0})"
            />
        </v-card>
        <v-card v-if="hasPermission('Use Developer Calls')">
          <v-toolbar>
            <TText
                  value="Dev Tools"
                  font_weight="500"
                  medium
            />
          </v-toolbar>
          <ButtonOutlined
                class="ma-2"
                text="copy taktid to clipboard"
                icon="restart"
                @buttonClicked="copyToClipboard(getIDToken);"
          />
          <ButtonOutlined
                class="ma-2"
                text="copy takttoken to clipboard"
                icon="restart"
                @buttonClicked="copyToClipboard(getToken);"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TText from '@/components/Taktify/TText.component.vue'
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'
import LocaleChanger from '@/components/LocaleChanger.component.vue';
import NavBarSwitch from '@/components/AppLayout/NavBarSwitch.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

export default {
  name: 'GeneralSettings',
  components: {
    ButtonOutlined,
    NavBarSwitch,
    LocaleChanger,
    StandardSwitch,
    TText
  },
  data: () => ({
    lightTheme: false,
    language: false,
    live_sync_setting: false,
  }),
  created(){
    if(localStorage.getItem('live_sync') === "true"){ //local storage get returns string...
      this.live_sync_setting = true;
    }else if(localStorage.getItem('live_sync') === "false"){
      this.live_sync_setting = false;
    }else{
      this.setLiveSyncCookie(true) //if cookie isnt set initialize it to true
    }
  },
  methods: {
    ...mapActions('Language', [
      'switchEdit',
      'requestAllLanguages'
    ]),
    ...mapActions('Business', [
      'requestBusinessPermissions',
    ]),
    ...mapActions('Auth', [
      'requestPermissions',
    ]),
    ...mapActions('ProjectMember', [
      'requestPPermissions',
    ]),
    setLiveSyncCookie(value){
      this.live_sync_setting = value;
      localStorage.setItem('live_sync', value);
    },
    copyToClipboard(msg) {
      navigator.clipboard.writeText(msg);
    },

  },
  computed: {
    ...mapGetters('Language', [
      'isEdit'
    ]),
    ...mapGetters('Auth', [
      'hasPermission',
      'getToken',
      'getIDToken'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
    ]),
  },
  watch: {
    lightTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  },
}
</script>

<style lang="css" scoped>
</style>
